import $ from 'jquery';

// bootstrap-notify の既定のテンプレートから、閉じるボタンだけを変えたもの。
// 既定だとボタン自体が aria-hidden で読み上げから辿れず、名前も「×」だけなので、
// ボタンに名前を付け、見た目の × だけを読み上げから隠す。モーダルの × と名前が重ならないよう「メッセージを閉じる」にする
const TEMPLATE =
  '<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert">' +
  '<button type="button" class="close" data-notify="dismiss" aria-label="メッセージを閉じる"><span aria-hidden="true">&times;</span></button>' +
  '<span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span>' +
  '<div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div>' +
  '<a href="{3}" target="{4}" data-notify="url"></a>' +
  '</div>';

export default function flashMessage(
  title: string,
  message: string,
  from: string,
  align: string,
  icon: string,
  type: string,
  animIn: string,
  animOut: string,
) {
  $.notify(
    {
      icon: icon,
      title: title,
      message: message,
    },
    {
      type: type,
      // bootstrap-notify の既定（1031）だとモーダル（Bootstrap 4 の .modal は 1050）の裏に隠れるため、モーダルより手前にする。
      // popover（1060）とは同じ値で、tooltip（1070）より奥
      z_index: 1060,
      template: TEMPLATE,
      placement: {
        from: from,
        align: align,
      },
      animate: {
        enter: animIn,
        exit: animOut,
      },
    },
  );
}

export type FlashMessageType = 'info' | 'success' | 'warning' | 'danger';

export function simpleFlashMessage(
  message: string,
  type: FlashMessageType = 'info',
) {
  flashMessage(
    '',
    message,
    'top',
    'center',
    'fa fa-info-circle',
    type,
    'animated fadeInDown',
    'animated fadeOutUp',
  );
}
